













import forEach from 'lodash/forEach';
import throttle from 'lodash/throttle';
import { Component, Prop } from 'vue-property-decorator';
import { dataLayer } from '../globals';
import { EventBus } from '../helpers/bus';
import BaseComponent from './Base';
import Swiper, { ISwiperComponent } from './Swiper.vue';

export interface Slide {
    src?: string;
    title?: string;
    w?: number;
    h?: number;
    html?: string;
}

@Component({
    components: {
        Swiper,
    },
})
export default class HorizontalSwiper extends BaseComponent {
    public readonly $refs: {
        swiper: any,
    };

    @Prop({ type: Number, default: 768 }) protected readonly minWidth: number;
    @Prop({ type: [String, Number, Function], default: 'auto' }) protected readonly slidesPerView: any;
    @Prop({ type: Boolean, default: true }) protected readonly preventClick: boolean;
    @Prop({ type: Boolean, default: false }) protected readonly isAdaptive: boolean;
    @Prop({ type: Boolean, default: true }) protected readonly hasCounter: boolean;
    @Prop({ type: Number, default: 0 }) protected readonly slideWidth: number;
    @Prop({ type: String, default: 'Horizontal Swiper' }) protected readonly gtmCategory: string;
    @Prop({ type: String, default: '#fff' }) protected readonly backgroundColor: string;

    protected items: any[] = [];
    protected isVisible: boolean = true;
    protected slidesCount: number = 1;
    protected slideIndex: number = 0;
    protected swiperOption: any = {
        slidesPerView: this.slidesPerView,
        initialSlide: 0,
        watchOverflow: true,
        autoHeight: this.isAdaptive,
        navigation: {
            nextEl: `#${this.uniqId}_next`,
            prevEl: `#${this.uniqId}_prev`,
        },
        pagination: {
          el: '.pagination',
          clickable: true,
          /*renderBullet: function (index, className) {
            return `<span class="dot swiper-pagination-bullet">${index}</span>`;
          },*/
        },
    };

    protected get swiper(): ISwiperComponent {
        return (this.$refs.swiper as ISwiperComponent);
    }

    protected updateSlidesPerView(slides: number | string): void {
        this.swiperOption.slidesPerView = slides;
        this.swiper.setSlidesPerView(slides);
    }

    protected updateIfVisible(): any {
        if (!this.isVisible && this.$el.offsetParent !== null) {
            this.isVisible = true;
            this.init();
        }
    }

    protected init(): any {
        const vm = this;
        if (!vm.isVisible) {
            return;
        }
        forEach(this.swiper.getSlides(), (slide: Slide, index) => {
            const link: HTMLAnchorElement | null = (slide as HTMLElement).querySelector('a');

            // It's ugly fix for ugly solution.
            // webp, jpg, jpeg, gif, png
            if (link === null
                || (!['.webp', '.jpg', '.jpeg', '.png', '.gif'].find((item) => link.href.includes(item)) && !link.classList.contains('c-tile--video'))
            ) {
                return;
            }

            // TODO Image sizes issue
            const src: string = link ? (link.href || '') : '';
            if (!link.classList.contains('c-tile--video')) {
                const item: any = {
                    src,
                    title: (slide as HTMLElement).dataset.title,
                    initialPosition: { x: 0, y: 0 },
                };
                vm.items.push(item);
                const img = new Image();
                img.addEventListener('load', function() {
                    item.w = this.naturalWidth;
                    item.h = this.naturalHeight;
                });
                img.src = src;
            } else {
                vm.items.push({
                    src: '',
                    html: '<div class="u-video-center"><div class="pswp__video-container"><div is="youtube-video" class="pswp__video" src="' + link.href + '"></div></div></div>',
                });
            }
            link.addEventListener('click', (event) => {
                dataLayer.push({
                    eventAction: 'Slide click',
                    eventCategory: vm.gtmCategory,
                    event: 'horizontalSwiper:slideClick',
                });
                vm.$emit('slideClick', vm.items, index, slide, vm.swiper, event);
                if (vm.preventClick) {
                    event.preventDefault();
                }
            });
        });

        if (this.slideWidth > 0 && this.slidesPerView !== 'auto') {
            this.onResize({ width: this.$el.offsetWidth });
            EventBus.$on('windowResize', () => {
                this.onResize({ width: this.$el.offsetWidth });
            });
        } else if (window.innerWidth < this.minWidth) {
            this.updateSlidesPerView(1);
        }

        this.$emit('init', this.$refs.swiper);
        this.swiper.update();
    }

    /**
     * This function must be triggered only if there is a number of slides set.
     *
     * @param {number} width  Parent element width
     */
    protected onResize({ width }: { width: number }): void {
        const slidesCount = this.swiperOption.slidesPerView;
        const maxSlidesPerView = parseInt(this.slidesPerView, 10);
        let slidesCanFit = Math.round(width / this.slideWidth);
        if (slidesCanFit > maxSlidesPerView) {
            slidesCanFit = maxSlidesPerView;
        }
        if (slidesCanFit < 1) {
            slidesCanFit = 1;
        }
        if (slidesCount !== slidesCanFit) {
            this.updateSlidesPerView(slidesCanFit);
        }
    }

    protected updateIndexes(): void {
        setTimeout(() => {
            this.slideIndex = this.swiper.getSlideIndex();
            this.slidesCount = this.swiper.getSlides().length;
        }, 50);
    }

    protected mounted(): void {
        const vm = this;
        this.updateIfVisible();
        const updateManually = throttle(this.updateIfVisible, 150, { leading: false });
        this.$refs.swiper.$on('slideChange', () => {
            dataLayer.push({
                eventAction: 'Slide change',
                eventCategory: vm.gtmCategory,
                event: 'horizontalSwiper:slideChange',
            });
            if (vm.hasCounter) {
                vm.updateIndexes();
            }
        });

        if (this.hasCounter) {
            this.updateIndexes();
        }
        EventBus.$on('updateSwipers', updateManually);
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HorizontalSwiperRounded.vue